const autoNgTemplateLoaderTemplate1 = require('./host-overview.html');

angular.module('shbdeployer.docker').component('hostOverview', {
  templateUrl: autoNgTemplateLoaderTemplate1,
  bindings: {
    hostDetails: '<',
    engineDetails: '<',
    devices: '<',
    disks: '<',
    isAgent: '<',
    offlineMode: '<',
    agentApiVersion: '<',
    refreshUrl: '@',
    browseUrl: '@',
    hostFeaturesEnabled: '<',
  },
  transclude: true,
});
